import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-file-cloud-icon',
  templateUrl: './files-file-cloud.component.html'
})
export class FilesFileCloudComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
